module.exports = __webpack_public_path__ + "img/Facebook.bb71ef68.svg";